<template>
  <div>

    <div class="pb-3 pt-3">
      <h5>
        <strong @click="$emit('toIndex')" style="cursor: pointer">
          <arrow-left-icon class="pb-1"/>
          Voltar para a listagem de empresas
        </strong>
      </h5>
    </div>

    <div class="ibox">
      <div class="ibox-title pt-3">
        <h5><strong>Empresa</strong></h5>
      </div>
      <div class="ibox-content">

        <div class="row">
          <div class="col-md-6">
            <div>
              <p><strong>{{ provider.name | uppercase }}</strong></p>
            </div>
            <div>
              <p><strong>CNPJ: </strong>{{ provider.cnpj | cnpj }}</p>
            </div>
            <div>
              <p><strong>IE: </strong>{{ provider.ie }}</p>
            </div>
            <div>
              <p><strong>IM: </strong>{{ provider.im }}</p>
            </div>
            <div>
              <p><strong>UF: </strong>{{ provider.uf }}</p>
            </div>
          </div>

          <div class="col-md-6">
            <div>
              <p><strong>Data da criação: </strong>{{ provider.createdAt | date }}</p>
            </div>
            <div>
              <p><strong>Email: </strong>{{ provider.email }}</p>
            </div>
            <div>
              <p><strong>Telefone: </strong>{{ provider.phone }}</p>
            </div>
            <div>
              <p><strong>Criado por: </strong>{{ provider.createdBy }}</p>
            </div>
          </div>
        </div>

        <div class="row mt-2">
          <div class="col-md-12">
            <button v-if="$withPolicy('application', 'companies/insert_or_update')"
                    class="btn btn-outline btn-md mr-2"
                    @click="$emit('editCompany', provider)">
              Editar
            </button>

            <button v-if="$withPolicy('application', 'companies/delete')" class="btn btn-outline-red float-right"
                    @click="$emit('sendDeleteCompany', provider)">
              Excluir empresa
            </button>
          </div>
        </div>
      </div>
    </div>

    <CardCompanies :provider="provider"/>

  </div>
</template>

<script>
  import CardCompanies from '@/components/providers/container/CardCompanies'
  import { ArrowLeftIcon } from 'vue-feather-icons'

  export default {
    components: { ArrowLeftIcon, CardCompanies },
    methods: {
      checkDate(string) {
        if (string) {
          const date = new Date(string)
          return date > new Date()
        }
      },
    },
    name: 'Show',
    props: {
      provider: { required: true, type: Object }
    }
  }
</script>

<style scoped lang="scss">
 .card{
    height: 100%;
  }

  p{
    color: black;
  }

  .table td{
    vertical-align: middle;
  }

</style>
